'use client';
import style from '@damascus-components/ErrorState/ErrorState.module.scss';
import {datadogLogs} from '@datadog/browser-logs';
import {useEffect} from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  useEffect(() => {
    datadogLogs.logger.error('error page reached',error);
  }, [error]);
  const handleTryAgainClick = () => {
    reset();
  };

  return (
    <>
      <div className={style.container} data-testid='error'>
        <h1>Oops!</h1>
        <h3>Unable to process your request at the moment</h3>
        <p>
          Something went wrong. Would you like to{' '}
          <a onClick={handleTryAgainClick}>try again?</a>
        </p>
      </div>
    </>
  );
}
